import React, { Component } from "react";
import PropTypes from "prop-types";


export default class TYDropDownItem extends Component{
    render(){
        return (
            <div className="dropdown-item" onClick={ this.props.onClick }>
                { this.props.children }
            </div>
        );
    }
}

TYDropDownItem.propTypes = {
    onClick: PropTypes.func
};

TYDropDownItem.defaultProps = {
    onClick: () => {}
};



// WEBPACK FOOTER //
// ./src/components/TYDropDown/item.js